import { useStore } from "vuex";
import { usePermissions } from '@/composables/usePermissions';

import { createRouter, createMemoryHistory, createWebHistory } from "vue-router";

const isServer = typeof window === "undefined";
const history = isServer ? createMemoryHistory() : createWebHistory();


// Helper function to check if a plan is selected
const hasSelectedPlan = () => {
  try {
    const sessionPlan = sessionStorage.getItem('selectedMembershipPlan');
    const localPlan = localStorage.getItem('selectedMembershipPlan');
    const hasSessionPlan = !!(sessionPlan && sessionPlan !== 'undefined' && sessionPlan !== 'null');
    const hasLocalPlan = !!(localPlan && localPlan !== 'undefined' && localPlan !== 'null');
    
    console.log("hasSelectedPlan check - session:", hasSessionPlan, "local:", hasLocalPlan);
    return hasSessionPlan || hasLocalPlan;
  } catch (error) {
    console.error("Error checking selected plan:", error);
    return false;
  }
};

// Helper function to get selected plan details
const getSelectedPlan = () => {
  try {
    const sessionPlan = sessionStorage.getItem('selectedMembershipPlan');
    const localPlan = localStorage.getItem('selectedMembershipPlan');
    const planStr = sessionPlan || localPlan;
    
    if (planStr && planStr !== 'undefined' && planStr !== 'null') {
      return JSON.parse(planStr);
    }
    return null;
  } catch (e) {
    console.error('Error parsing selected plan:', e);
    return null;
  }
};

// Helper function to clear selected plan (used after successful payment)
export const clearSelectedPlan = () => {
  try {
    sessionStorage.removeItem('selectedMembershipPlan');
    localStorage.removeItem('selectedMembershipPlan');
    console.log("Selected plan cleared from storage");
  } catch (error) {
    console.error("Error clearing selected plan:", error);
  }
};

// Helper function to validate selected plan data
const isValidSelectedPlan = () => {
  const plan = getSelectedPlan();
  if (!plan) return false;
  
  // Check if plan has required fields
  const hasRequiredFields = plan.id && plan.name && plan.price && plan.materialCode;
  if (!hasRequiredFields) {
    console.warn("Invalid plan data - missing required fields:", plan);
    return false;
  }
  
  // Check if plan is not expired (optional, if you want to add expiry)
  if (plan.selectedAt) {
    const selectedTime = new Date(plan.selectedAt).getTime();
    const currentTime = new Date().getTime();
    const hoursSinceSelection = (currentTime - selectedTime) / (1000 * 60 * 60);
    
    // Plan selection expires after 24 hours
    if (hoursSinceSelection > 24) {
      console.warn("Plan selection expired after 24 hours");
      clearSelectedPlan();
      return false;
    }
  }
  
  return true;
};


const routes = [

  // Admin Dashboard
  {
    path: "/lifelayerDashboard",
    name: "lifelayerDashboard",
    component: () => import("../Admin_Dashboard/lifelayerDashboard.vue"),
  },
  // end
  //Testing route for location can be removed later
  {
    path: "/UserLocation",
    name: "UserLocation",
    component: () => import("@/utils/UserLocation.vue")
  },
  //Portfolio Routes start
  {
    path: "/referraltree/:userId",
    name: "Referral Tree",
    component: () => import("../portfolio/ReferralTree.vue"),
  },
  // Credits
    {
    path: "/my-credits",
    name: "My Credits",
    component: () => import("../portfolio/MyCredits.vue"),
  },
  {
    path: "/coinsDashboard",
    name: "Coins Dashboard",
    component: () => import("../portfolio/CoinDashboard.vue"),
  },
  {
  path: '/upcoming',
  name: 'UpcomingActivities',
  component: () => import('@/UpcomingActivities/UpcomingActivities.vue'),
  meta: {
    title: 'Upcoming'
  }
},
  // update profile routes\
  {
    path: "/Doctor-Profile-Details",
    name: "formNew",
    component: () => import("@/profiles/resumeTemplate/formNew.vue"),
  },
  // resume routes
  {
    path: "/savedTemplate/:id",
    name: "savedTemplate",
    component: () => import("@/saved resume template/savedTemplate.vue"),
  },
  {
    path: "/direct-commission-history/:userId",
    name: "Direct Commission",
    component: () => import("../portfolio/DirectCommission.vue"),
  },
  {
    path: "/commissionHistory/:level",
    name: "Level wise Commission",
    component: () => import("../portfolio/LevelWiseCommission.vue"),
  },
  {
    path: "/referral-commission/:id",
    name: "Referral Commission",
    component: () => import("../portfolio/ReferralCommissioin.vue"),
  },

  //Chat One to One chat
  {
    path: "/Chatpersonal/:id?",
    name: "Chat personal",
    component: () => import("@/Chat/personalChat.vue"),
  },
  {
    path: "/chatUser/:id?",
    // beforeEnter: (to, from, next) => {
    //   next("/ChatRoom")
    // },
    name: "Chat User",
    component: () => import("@/Chat/conectionChat.vue"),
  },
  {
    path: "/ChatRoom/:id?",
    name: "Chat Room",
    component: () => import("@/Chat/ChatRoom.vue"),
  },
  {
    path: "/newChatRoom/:id",
    name: "New Chat",
    component: () => import("@/Chat/firstFile.vue"),
  },




  // Personal Task Routes
  {
    path: "/personaltask",
    name: "personaltask",
    component: () => import("../MyPersonalTask/MyPersonalTask.vue"),
  },
  // Invoices routes start
  {
    path: "/invoices",
    name: " Inovice Dashboard",
    component: () => import("@/InvoiceModels/InvoiceDashboard.vue")
  },
  {
    path: "/transactions",
    name: " Transactions",
    component: () => import("@/InvoiceModels/Transactions.vue")
  },
  // Invoices routes end
  // E-learing routes start 
  // E-learing routes start 
  {
    path: '/anotherChapter',
    name: 'anotherChapter',
    component: () => import('@/e-learing/Another_chapter.vue'),
  },
  {
    path:'/E-LearningAdminDashboard',
    name: 'E-LearningAdminDashboard',
    component: () => import('@/e-learing/admin-panel/Dashboard.vue'),
  },

  {
    path: '/course/:id',
    name: 'CourseDetails',
    component: () => import('@/e-learing/CourseDetails.vue'),
  },
  {
    path: '/courses', // The URL path you want to match
    name: 'courses',  // Ensure this is the same name you're trying to use in your code
    component: () => import('@/e-learing/course_Cards.vue') // The component for this route
  },
  {
    path: '/teacherscourses', // The URL path you want to match
    name: 'teachercourses',  // Ensure this is the same name you're trying to use in your code
    // eslint-disable-next-line
    component: () => import('@/e-learing/teachersCard.vue')
  },

  {
    path: '/EducationHome',
    name: 'EducationHome',
    component: () => import('@/e-learing/EducationHome.vue'),
  },
  { path: "/teacher-live-class/:id", name: "teacherLiveClass", component: () => import("@/e-learing/TeacherLiveClass.vue") },
   { path: "/student-live-class/:id", name: "studentLiveClass", component: () => import("@/e-learing/StudentLiveClass.vue") },
  {
    path: '/EduNavbar',
    name: 'EduNavbar',
    component: () => import('@/e-learing/EduNavbar.vue'),
  },
  {
    path: '/uploadContent/:id?',
    name: 'uploadContent',
    component: () => import('@/e-learing/uploadContent.vue'),
    props: true
  },
  {
    path: '/studentPage',
    name: 'studentPage',
    component: () => import('@/e-learing/studentPage.vue'),

  },
  {
    path: '/lernersDashboard',
    name: 'lernersDashboard',
    component: () => import('@/e-learing/lerners_dashboard.vue'),
  },
  {
    path: '/teachersDashboard/:id',
    name: 'teachersDashboard',
    component: () => import('@/e-learing/teachers_dashboard.vue'),

  },
  {
    path: '/purchaseSuccess',
    name: 'purchaseSuccess',
    component: () => import('@/e-learing/purchaseSuccess.vue'),

  },
  {
    path: '/uploadChapter/:id?',
    name: 'uploadChapter',
    component: () => import('@/e-learing/upload_chapter.vue'),
    props: true

  },
  {
    path: '/anotherchapter/:id?',
    name: 'anotherChapter',
    component: () => import('@/e-learing/Another_chapter.vue'),


  },
  {
    path: '/checkoutEdu/:id',
    name: 'checkoutEdu',
    component: () => import('@/e-learing/Edu_Checkout.vue'),

  },
  {
    path: '/Elearning',
    name: 'Elearning',
    component: () => import('@/e-learing/E-learning.vue'),

  },

  {
    path: '/EduDashboard',
    name: 'EduDashboard',
    component: () => import('@/e-learing/e-learning_Dashboard.vue'),

  },
  // E-learing routes end
  //CRM Routes

   {
    path: '/create-guest-category',
    name: 'CreateGuestCategory',
    component: () => import("../crm/create_guest_category.vue"),
  },
  {
    path: "/add_customer_data",
    name: "add_customer_data",
    component: () => import("@/crm/add_customer_data.vue"),
  },


  {
    path: "/select_data_for_marketing_compaign",
    name: "select_data_for_invitation",
    component: () => import("../crm/select_data_for_invitation.vue"),
  },
  {
    path: "/send_invitation_to_customer",
    name: "send_invitation_to_customer",
    component: () => import("@/crm/send_invitation_to_customer.vue"),
  },
  {
    path: "/select_preview_data",
    name: "select_preview_data",
    component: () => import("@/crm/select_preview_data.vue")

  },
  {
    path: "/send_invitation_to_customer",
    name: "send_invitation_to_customer",
    component: () => import("@/crm/send_invitation_to_customer.vue"),
  },
  {
    path: "/PreviewDocument/:templateId",
    name: "PreviewDocument",
    component: () => import("@/crm/previewDocument.vue"),
  },
  {
    path: "/editorPageTemplate/:templateId?",
    name: "EditorPageTemplate",
    component: () => import("@/crm/EditorPage.vue"),
    props: true, // This allows you to pass params to the component
  },
  {
    path: "/templateSelectionPage",
    name: "TemplateSelectionPage",
    component: () => import("@/crm/TemplateSelectionPage.vue"),
  },

  {
    path: "/Affiliate_Associate",
    name: "Affiliate_Assocaite",
    component: () => import("../Affiliate_Associate_management/Affiliate_Associate.vue"),
  },
  {
    path: "/interpreter",
    name: "interpreter",
    component: () => import("../Affiliate_Associate_management/Interpreter.vue"),
  },
  // -------------Letter & Drafts For CRM-------------------------
    {
    path: "/compaign-report",
    name: "CampaignReportPage",
    props: true,  // This allows you to pass params to the component
    component: () => import("@/LetterAndDraftsForCRM/CompaignReportPage.vue")
  },
  {
    path: "/crm-editorPageTemplate/:templateId?",
    name: "CRM_EditorPageTemplate",
    props: true,  // This allows you to pass params to the component
    component: () => import("@/LetterAndDraftsForCRM/EditorPage.vue")
  },

  {
    path: "/crm-templateSelectionPage",
    name: "CRM_TemplateSelectionPage",
    component: () => import("@/LetterAndDraftsForCRM/TemplateSelectionPage.vue")
  },



  // appointment Video Routes start
  {
    path: "/recordings/:appointmentId",
    name: "ViewRecording",
    component: () => import("../AppointmentBlock/ViewVideoCallRecording.vue"),
  },
  {
    path: "/appointment_videocall/:id?",
    name: "Appointment Video Call",
    component: () => import("@/AppointmentBlock/AppointmentVideoCall.vue"),
  },{
    path: "/dragablechat",
    name: "chatdragbox",
    component: () => import("@/AppointmentBlock/dragablechat.vue"),
  },
  {
    path: "/department_day_book",
    name: "department_day_book",
    component: () => import("@/AppointmentBlock/department_day_book.vue"),
  },
  {
    path: "/appointmentvideochat/:id?",
    name: "Appointment Video Chat",
    component: () => import("@/AppointmentBlock/AppointmentVideoCallChat.vue"),
  },
  {
    path: "/AppointmentScreenVideo",
    name: "AppointmentScreen",
    component: () => import("@/appointment-screen/AppointmentScreenVideo.vue"),
  },
  {
    path: "/streamer",
    name: "Streamer",
    component: () => import("@/Stream/Streaming.vue")
  },

  // appointment Video Routes end

  // job board routes start
  {
    path: "/ViewForRecuiter/:id",
    name: "ViewForRecuiter",
    component: () =>
      import(
        "../jobBoard/ViewForRecuiter.vue"
      ),
  },
  {
    path: "/DiscriptionJob",
    name: "Discript",
    component: () =>
      import(
        "../jobBoard/DiscriptionJob.vue"
      ),
  },
  {
    path: "/savedandAppliedJobs",
    name: "jobboard myitem",
    component: () =>
      import(
        "../jobBoard/jobs_myitem.vue"
      ),
  },
  // {
  //   path: "/homeJobs",
  //   name: "homeJobs",
  //   component: () =>
  //     import(
  //       "../jobBoard/homeJobs.vue"
  //     ),
  // },
  {
    path: "/jobs/:id",
    name: "jobs",
    component: () =>
      import(
        "../jobBoard/jobs_section.vue"
      ),
  },
  {
    path: "/postFreeJobs",
    name: "postFree",
    component: () =>
      import(
        "../jobBoard/postFreeJobs.vue"
      ),
  },
  {
    path: "/reciveApplications",
    name: "reciveApplications",
    component: () =>
      import(
        "../jobBoard/reciveApplications.vue"
      ),
  },
  {
    path: "/review",
    name: "review",
    component: () =>
      import(
        "../jobBoard/review_jobs.vue"
      ),
  },
  {
    path: "/searchJob",
    name: "searchJob",
    component: () =>
      import(
        "../jobBoard/searchJob.vue"
      ),
  },
  {
    path: "/showJobsPage",
    name: "showJobsPage",
    component: () =>
      import(
        "../jobBoard/showJobsPage.vue"
      ),
  },
  {
    path: "/postJobs",
    name: "postJobs",
    component: () =>
      import(
        "../jobBoard/postJobs.vue"
      ),
  },
  {
    path: "/salaryguide",
    name: "salaryguide",
    component: () =>
      import(
        "../jobBoard/salaryguides_jobs.vue"
      ),
  },
  {
    path: "/news",
    name: "news",
    component: () =>
      import(
        "../jobBoard/news_jobs.vue"
      ),
  },
  {
    path: "/demifile",
    name: "demifile",
    component: () =>
      import(
        "../jobBoard/demifile_jobs.vue"
      ),
  },
  {
    path: "/JobDashboard",
    name: "JobDashboard",
    component: () =>
      import(
        "../jobBoard/JobDashboard.vue"
      ),
  },
  {
    path: "/Draft/:id",
    name: "Draft",
    component: () =>
      import(
        "../jobBoard/drafts_section.vue"
      ),
  },
  {
    path: "/chatForApplicant/:roomId",
    name: "chatForApplicant",
    
    component: () =>
      import(
        "../jobBoard/chatForApplicant.vue"
      ),
      
  },
  {
    path: "/InterviewMeeting/:id",
    name: "InterviewMeeting",
    component: () =>
      import(
        "../jobBoard/InterviewMeeting.vue"
      ),
  },

  // job board routes end

  // not found page start here
{
  // New Vue Router 4 syntax for catch-all routes
  path: '/:pathMatch(.*)*',
  name: 'notFound',
  component: () => import('@/notFoundPage/errorPage.vue'),
  meta: {
    title: 'Page Not Found'
  }
},

  //Portfolio Routes end

  {
    path: "/",
    name: "LandingPage",
    component: () => import("@/login/login/LandingPage.vue"),
  },
  // Business Login
  {
    path: "/business/:company_code",
    name: "VendorProfile",
    component: () => import("@/profiles/vendor-profile/VendorProfile.vue"),

  },
  {
    path: "/customer",
    name: "CustomerProfile",
    component: () => import("@/profiles/customer-profile/CustomerProfile.vue"),
    meta: { permission: "own_customer_profile:access" },
    // meta: {
    //   title: "Patient Profile - Example App",
    //   requiresPatient: true, // Add a meta field to specify that the route requires admin privileges
    // },
  },
  {
    path: "/student",
    name: "StudentProfile",
    component: () => import("@/profiles/student-profile/StudentProfile.vue"),

  },
  {
    path: "/paramedics", 
    name: "ParamedcisProfile",
    component: () => import("@/profiles/paramedics-profile/ParamedicsProfile.vue"),

  },
  {
    path: "/doctor",
    name: "DoctorProfile",
    component: () => import("@/profiles/doctor-profile/DoctorProfile.vue"),
    // meta: { permission: "own_doctor_profile:access" },
    // meta: {
    //   title: "Doctor Profile - Example App",
    //   requiresDoctor: true, // Add a meta field to specify that the route requires admin privileges
    // },
  },
  {
    path: "/pet/:id",
    name: "PetProfile",
    component: () => import("@/profiles/pet-profile/PetProfile.vue"),

  },
  {
    path: "/follow_following_details",
    name: "ShowFollowFollowingDetails",
    component: () => import("@/profiles/doctor-profile/ShowFollowFollowingDetails.vue")
  },
  {
    path: "/doctor-dashboard",
    name: "DoctorDashboard",
    component: () => import("@/dashboards/DoctorDashboard.vue"),
    meta: { permission: "own_doctor_profile:access" },
  },
  {
    path: "/doctor-profile-completion",
    name: "DoctorProfileCompletion",
    component: () =>
      import(
        "@/profiles/doctor-profile/doctor-profile-completion/DoctorProfileCompletion.vue"
      ),
    meta: { permission: "own_doctor_profile:access", topbar_sidebar_hide: false },
  },
 
  {
    path: "/manage-permissions",
    name: "manage-permission",
    component: () => import("@/permissions/RoleTable.vue"),
    meta: { permission: "super_admin:access" },
  },
  {
    path: "/registration-payment",
    name: "RegistrationPayment",
    component: () => import("@/invite-member/RegistrationPayment.vue"),
    meta: { topbar_sidebar_hide: false,
       requiresAuth: true,
        allowUnpaid: true,
        requiresPlanSelection: true,
        permission: 'can_make_payment'
     },
  },
  {
    path: "/membership-plans",
    name: "/MembershipPlans",
    component: () => import("@/invite-member/MembershipPlans.vue"),
    meta: { topbar_sidebar_hide: false ,
      requiresAuth: true,
        allowUnpaid: true,
        requiresPlanSelection: false
    },
  },
  {
    path: "/registration-successful",
    name: "RegistrationThankyou",
    component: () => import("@/invite-member/RegistrationThankyou.vue"),
    meta: { topbar_sidebar_hide: false },
  },

  {
    path: "/registration-payment-successful/:userId?",
    name: "RegistrationPaymentThankyou",
    component: () => import("@/invite-member/RegistrationPaymentThankyou.vue"),
    meta: { topbar_sidebar_hide: false },
  },
  // my income 
  {
    path: '/my-income',
    name: 'IncomePage',
    component: () => import("@/my-income/myIncome.vue")
  },
  {
    path: "/send-invitation",
    name: "InvitationForm",
    component: () => import("@/invite-member/InvitationForm.vue"),
  },
  {
    path: "/details-send-invitation",
    name: "InvitatinData",
    component: () => import("@/invite-member/InvitationData.vue"),
  },

  // Health Records
  {
    path: "/add-health-record",
    name: "AddHealthRecord",
    component: () => import("@/health-record/AddHealthRecord.vue"),
  },
  {
    path: "/medicial_records",
    name: "medicial_records",
    component: () => import("@/health-record/medicialReportupload.vue"),
  },
  {
    path: "/view-myhealth-record",
    name: "ViewHealthRecord",
    component: () => import("@/health-record/ViewHealthRecord.vue"),
  },
  {
    path: "/patient-health-record/:id",
    name: "ViewPatientHealthRecord",
    component: () => import("@/health-record/ViewPatientHealthRecord.vue"),
  },
  {
    path: "/editmedicalrecord/:id",
    name: "EditHealthRecord",
    component: () => import("@/health-record/components/editmedicalrecord.vue"),
  },
  // ******** blog *****************
  {
    path: "/add-category",
    name: "AddCategory",
    component: () => import("@/blog/AddCategory.vue"),
  },
 {
    path: "/create-blog/:id?",
    name: "CreateBlog",
  component: () => import("@/blog/CreateBlog.vue"),
  },
  {
    path: "/blogs",
    name: "AllBlogs",
    component: () => import("@/blog/AllBlogs.vue"),
    meta: { publicLayout: true },                       // <-- NEW
  },
    {                                                       // <-- NEW route
    path: "/blog/:id",
    name: "BlogDetail",
    component: () => import("@/blog/BlogDetail.vue"),
    meta: { publicLayout: true, isPublic: true },
  },
  {
    path: "/my-blogs/drafts",
    name: "DraftBlogs",
    component: () => import("@/blog/DraftBlogs.vue"),
  },
  {
    path: "/knowledgebase",
    name: "KnowledgeBase",
    component: () => import("@/blog/KnowledgeBase.vue"),
  },
  {
    path: "/knowledgebase/:id",
    name: "readMoreknowledgebase",
    redirect: (to) => ({ name: "BlogDetail", params: { id: to.params.id } }),
  },
  {
    path: "/my-blogs",
    name: "MyBlogs",
    component: () => import("@/blog/MyBlogs.vue"),
  },
  {
    path: "/my-blogs/:id",
    name: "userShowblogs",
    redirect: (to) => ({ name: "BlogDetail", params: { id: to.params.id } }),
  },


  {
    path: "/subscribers",
    name: "subscriberlist",
    component: () => import("@/newsletter/subscriber/SubscribersPage.vue"),
  },

  {
    // Search insights - admin only (also protected on the API)
    path: "/search-insights",
    name: "SearchInsights",
    component: () => import("@/search-insights/SearchInsights.vue"),
    meta: { requiresAuth: true, requiresAdmin: true, noHeatmap: true },
  },
//signature upload
  {
    path: "/signature-upload",
    name: "SignatureUpload",
    component: () => import("../uploadSignature/signatureUpload.vue"), //PatientAppointmentBooking,
  },

  {
  path: "/receivedArticles",
  name: "ReceivedArticles",
  component: () => import("@/education-article/Receivedarticles.vue"),
},

   {
  path: "/editArticle/:id",
  name: "EditArticle",
  component: () => import("@/education-article/CreateArticle.vue")
},

    //Advertisement Routes
  // {
  //   path: "/advertisement_management",
  //   name: "AdvertisementManagement",
  //   component: () => import("@/advertisement_management/advertisementManagement.vue"),
  //   // props: (route) => ({
  //   //   edit: route.query.edit === 'true',
  //   //   editAdData: route.params.editAdData
  //   // })
  // },
  // {
  //   path: "/advertisement_management_dashboard",
  //   name: "AdvertisementManagementDashboard",
  //   component: () => import("@/advertisement_management/advertisementManagementDashboard.vue")
  // },
  // {
  //   path: "/advertisement_management_admin/:id",
  //   name: "AdvertisementManagementAdmin",
  //   component: () => import("@/advertisement_management/advertisementManagementAdmin.vue")
  // },
  // {
  //   path: "/advertisementInvoice",
  //   name: "AdvertisementInvoice",
  //   component: () => import("@/advertisement_management/advertisementInvoice.vue")
  // },

   //storage
  {
    path: "/storage",
    name: 'storage',
    component: ()=> import("@/storage-subscription/purchaseStorage.vue")
  },
   //Employee Profile
  {
    path: "/employee",
    name: "EmployeeProfile",
    component: () => import("@/profiles/employe-profile/EmployeeProfile.vue"),
   
  },

  {
    path: "/company-invitation",
    name: "companyinvitation",
    component: () => import("../VideoCall/CompanyInvite.vue"),
  },
  {
    path: "/follow-following-invitation",
    name: "followfollowinginvitation",
    component: () => import("../VideoCall/FollowFollowerInvite.vue"),
  },
  //Employee Profile
  {
    path: "/company-doctor",
    name: "CompanyDoctorProfile",
    component: () => import("@/profiles/company-doctor-profile/CompanyDoctorProfile.vue"),
   
  },
  {
    path: "/duty-roaster",
    name: "DutyRoaster",
    component: () => import("@/profiles/company-doctor-profile/CompanyDoctorDumy.vue"),
   
  },

  // ********* Big File Sharing ***********

  {
    path: "/large-file-upload",
    name: "LargeFileUpload",
    component: () => import("@/upload-files/LargeFileUpload.vue"),
  },
  {
    path: "/admin-file-dashboard",
    name: "AdminFileDashboard",
    component: () => import("@/upload-files/AdminFileDashboard.vue"),
  },
  {
    path: "/user-file-dashboard",
    name: "UserFileDashboard",
    component: () => import("@/upload-files/UserFileDashboard.vue"),
  },
  {
    path: "/admin-file-dashboard/:userId/files",
    name: "UserStats",
    component: () => import("@/upload-files/UserStats.vue"),
  },

  // <------------ company ------------>

  {
    path: "/sub_department_communication",
    name: "sub_department_communication",
    component: () => import("@/company/sub_department_communication.vue"),
  },
  {
    path: "/department_communication",
    name: "department_communication",
    component: () => import("@/company/department_communication.vue"),
  },
  {
    path: "/building_map",
    name: "building_map",
    component: () => import("@/company/building_map.vue"),
  },
  {
    path: "/building_structure",
    name: "building_structure",
    component: () => import("@/company/building_structure.vue"),
  },

  {
    path: "/company_directors_details",
    name: "company_directors_details",
    component: () => import("@/company/company_directors_details.vue"),
  },
  {
    path: "/industry",
    name: "company_industry",
    component: () => import("@/company/company_industry.vue"),
  },
  {
    path: "/dashboard_company",
    name: "dashboard_company",
    component: () => import("@/company/dashboard_company.vue"),
  },
  {
    path: "/company_creation",
    name: "company_creation",
    component: () => import("@/company/company_creation.vue"),
  },
  {
    path: "/operation_units",
    name: "operation_units",
    component: () => import("@/company/operation_units.vue"),
  },
  // <------------Service------------>

  {
    path: "/sub_service_mapping_with_sub_section_sub_department",
    name: "sub_service_mapping_with_sub_section_sub_department",
    component: () =>
      import(
        "../service-management/sub_service_mapping_with_sub_section_sub_department.vue"
      ),
  },
  {
    path: "/sub_service_mapping_with_section_department",
    name: "sub_service_mapping_with_section_department",
    component: () =>
      import(
        "../service-management/sub_service_mapping_with_section_department.vue"
      ),
  },
  {
    path: "/service_mapping_with_subsection_subdepartment",
    name: "service_mapping_with_subsection_subdepartment",
    component: () =>
      import(
        "../service-management/service_mapping_with_subsection_subdepartment.vue"
      ),
  },
  {
    path: "/service_mapping_with_section_department",
    name: "service_mapping_with_section_department",
    component: () =>
      import(
        "../service-management/service_mapping_with_section_department.vue"
      ),
  },
  {
    path: "/sub_service_transaction_remark",
    name: "sub_service_transaction_remark",
    component: () =>
      import("../service-management/sub_service_transaction_remark.vue"),
  },
  {
    path: "/service_transaction_remark",
    name: "service_transaction_remark",
    component: () =>
      import("../service-management/service_transaction_remark.vue"),
  },
  {
    path: "/sub_service_operational_configuration",
    name: "sub_service_operational_configuration",
    component: () =>
      import("../service-management/sub_service_operational_configuration.vue"),
  },
  {
    path: "/service_operational_configuration",
    name: "service_operational_configuration",
    component: () =>
      import("../service-management/service_operational_configuration.vue"),
  },
  {
    path: "/sub_service_classification_configuration",
    name: "sub_service_classification_configuration",
    component: () =>
      import(
        "../service-management/sub_service_classification_configuration.vue"
      ),
  },
  {
    path: "/service_classification_configuration",
    name: "service_classification_configuration",
    component: () =>
      import("../service-management/service_classification_configuration.vue"),
  },
  {
    path: "/sub_service_description",
    name: "sub_service_description",
    component: () =>
      import("../service-management/sub_service_description.vue"),
  },
  {
    path: "/service_description",
    name: "service_description",
    component: () => import("../service-management/service_description.vue"),
  },
  {
    path: "/sub_services",
    name: "sub_services",
    component: () => import("../service-management/sub_services.vue"),
  },
  {
    path: "/services",
    name: "services",
    component: () => import("../service-management/services_create.vue"),
  },
  {
    path: "/dashboard_Service_management",
    name: "dashboard_Service_management",
    component: () =>
      import("../service-management/dashboard_Service_management.vue"),
  },
  {
    path: "/service_group",
    name: "service_group",
    component: () => import("../service-management/service_group.vue"),
  },

  // <----------- hr --------------->
  {
  path: "/my_team_view",
  name: "my_team_view",
  component: () => import("@/hr-module/MyTeamView.vue"),
 
},
{
  path: "/my_group_view",
  name: "my_group_view",
  component: () => import("@/hr-module/MyGroupView.vue"),
  
},
  {
    path: "/workforce_movement_timings",
    name: "workforce_movement_timings",
    component: () => import("@/hr-module/workforce_movement_timings.vue"),
  },
  {
    path: "/workforce_employee_duty_roaster",
    name: "workforce_employee_duty_roaster",
    component: () => import("@/hr-module/workforce_employee_duty_roaster.vue"),
  },
  {
    path: "/workforce_mapping_staff",
    name: "workforce_mapping_staff",
    component: () => import("@/hr-module/workforce_mapping_staff.vue"),
  },
  {
    path: "/workforce_requirments_section",
    name: "workforce_requirments_section",
    component: () => import("@/hr-module/workforce_requirments_section.vue"),
  },
  {
    path: "/workforce_mapping_sections",
    name: "workforce_mapping_sections",
    component: () => import("@/hr-module/workforce_mapping_sections.vue"),
  },
  {
    path: "/worforce_management",
    name: "worforce_management",
    component: () => import("@/hr-module/worforce_management.vue"),
  },
  {
    path: "/user_roles",
    name: "user_roles",
    component: () => import("@/hr-module/user_roles.vue"),
  },
  {
    path: "/user_sub_group",
    name: "user_sub_group",
    component: () => import("@/hr-module/user_sub_group.vue"),
  },
  {
    path: "/user_group",
    name: "user_group",
    component: () => import("@/hr-module/user_group.vue"),
  },
  {
    path: "/user_category",
    name: "user_category",
    component: () => import("@/hr-module/user_category.vue"),
  },
  {
    path: "/team_financial_share",
    name: "team_financial_share",
    component: () => import("@/hr-module/team_financial_share.vue"),
  },
  {
    path: "/member_team",
    name: "member_team",
    component: () => import("@/hr-module/member_team.vue"),
  },
  {
    path: "/user_team_workforce",
    name: "user_team_workforce",
    component: () => import("@/hr-module/user_team_workforce.vue"),
  },
  {
    path: "/user_designation",
    name: "user_designation",
    component: () => import("@/hr-module/user_designation.vue"),
  },
  {
    path: "/user_grade",
    name: "user_grade",
    component: () => import("@/hr-module/user_grade.vue"),
  },
  {
    path: "/user_roles_responsibility",
    name: "user_roles_responsibility",
    component: () => import("@/hr-module/user_roles_responsibility.vue"),
  },
  {
    path: "/user_financial_details",
    name: "user_financial_details",
    component: () => import("@/hr-module/user_financial_details.vue"),
  },
  {
    path: "/user_employment",
    name: "user_employment",
    component: () => import("@/hr-module/user_employment.vue"),
  },
  {
    path: "/user_management",
    name: "user_management",
    component: () => import("@/hr-module/user_management.vue"),
  },
  {
    path: "/employment_type",
    name: "employment_type",
    component: () => import("@/hr-module/employment_type.vue"),
  },
  {
    path: "/section_departments_timings",
    name: "section_departments_timings",
    component: () => import("@/hr-module/section_departments_timings.vue"),
  },
  {
    path: "/company_working_shifts",
    name: "company_working_shifts",
    component: () => import("@/hr-module/company_working_shifts.vue"),
  },
  {
    path: "/company_calendar_holiday",
    name: "company_calendar_holiday",
    component: () => import("@/hr-module/company_calendar_holiday.vue"),
  },
  {
    path: "/company_calender",
    name: "company_calender",
    component: () => import("@/hr-module/company_calender.vue"),
  },
  {
    path: "/liscense_details",
    name: "liscense_details",
    component: () => import("@/hr-module/liscense_details.vue"),
  },
  {
    path: "/skill_set_designation",
    name: "skill_set_designation",
    component: () => import("@/hr-module/skill_set_designation.vue"),
  },
  {
    path: "/skill_set",
    name: "skill_set",
    component: () => import("@/hr-module/skill_set.vue"),
  },
  {
    path: "/training",
    name: "training",
    component: () => import("@/hr-module/user_training.vue"),
  },
  {
    path: "/maintaining_scheduling_reason",
    name: "maintaining_scheduling_reason",
    component: () => import("@/hr-module/maintaining_scheduling_reason.vue"),
  },
  {
    path: "/dashboard_hr_module",
    name: "dashboard_hr_module",
    component: () => import("@/hr-module/dashboard_hr_module.vue"),
  },
  {
    path: "/employee_grade",
    name: "employee_grade",
    component: () => import("@/hr-module/employee_grade.vue"),
  },


  //**************Item Management**************** */

  {
    path: "/item_mapping_with_sub_section_sub_department",
    name: "item_mapping_with_sub_section_sub_department",
    component: () =>
      import(
        "../item-management/item_mapping_with_sub_section_sub_department.vue"
      ),
  },
  {
    path: "/item_mapping_with_section_department",
    name: "item_mapping_with_section_department",
    component: () =>
      import("../item-management/item_mapping_with_section_department.vue"),
  },
  {
    path: "/item_transaction_remarks",
    name: "item_transaction_remarks",
    component: () => import("../item-management/item_transaction_remarks.vue"),
  },
  {
    path: "/item_classification_configuration",
    name: "item_classification_configuration",
    component: () =>
      import("../item-management/item_classification_configuration.vue"),
  },
  {
    path: "/material_configuration",
    name: "material_configuration",
    component: () => import("../item-management/material_configuration.vue"),
  },

  {
    path: "/item_description_code",
    name: "item_description_code",
    component: () => import("../item-management/item_description_code.vue"),
  },

  {
    path: "/item_drug",
    name: "item_drug",
    component: () => import("../item-management/item_drug.vue"),
  },

  {
    path: "/item_create",
    name: "item",
    component: () => import("../item-management/item_create.vue"),
  },
  {
    path: "/brand",
    name: "brand",
    component: () => import("../item-management/brand_create.vue"),
  },
  {
    path: "/item_sub_category",
    name: "item_sub_category",
    component: () => import("../item-management/item_sub_category.vue"),
  },
  {
    path: "/item_category",
    name: "item_category",
    component: () => import("../item-management/item_category.vue"),
  },
  {
    path: "/item_class",
    name: "item_class",
    component: () => import("../item-management/item_class.vue"),
  },
  {
    path: "/material_sub_group",
    name: "material_sub_group",
    component: () => import("../item-management/material_sub_group.vue"),
  },
  {
    path: "/material_group",
    name: "material_group",
    component: () => import("../item-management/material_group.vue"),
  },
  {
    path: "/material_type",
    name: "material_type",
    component: () => import("../item-management/material_type.vue"),
  },
  {
    path: "/dashboard_item_management",
    name: "dashboard_item_management",
    component: () => import("../item-management/dashboard_item_management.vue"),
  },
  {
    path: "/material_category",
    name: "material_category",
    component: () => import("../item-management/material_category.vue"),
  },

  {
    path: "/item_pricing",
    name: "item_pricing",
    component: () => import("../item-management/item_pricing.vue"),
  },

  /*****************Measurment Unit***************/

  {
    path: "/equivalent_measurement_unit",
    name: "equivalent_measurement_unit",
    component: () =>
      import("../measurement_unit/equivalent_measurement_unit.vue"),
  },
  {
    path: "/dashboard_measurement_unit",
    name: "dashboard_measurement_unit",
    component: () =>
      import("../measurement_unit/dashboard_measurement_unit.vue"),
  },
  {
    path: "/measurement_unit",
    name: "measurement_unit",
    component: () => import("../measurement_unit/measurement_unit.vue"),
  },

  // // tests
  // {
  //   path: "/referraltree/:userId",
  //   name: "Referral Tree",
  //   component: () => import("@/onlyTestingPurpose/ReferralTree.vue"),
  // },

  // --------------SHow All Doctors-------------------
  {
    path: "/All-Doctors",
    name: "AllDoctors",
    component: () => import("@/ShowAllDoctors/AllDoctors.vue"),
  },
  {
    path: "/pet-doctors",
    name: "PetDoctors",
    component: () => import("@/ShowAllDoctors/PetDoctors.vue"),
   },
  {
    path: "/Show-Doctors-Profile/:id",
    name: "ShowDoctorProfile",
    component: () => import("@/ShowAllDoctors/ShowDoctorProfile.vue"),
  },
  // -------------Show Company cards---------------------
  {
    path: "/Company-Cards",
    name: "CompanyCards",
    component: () => import("@/company-cards/CompanyCards.vue"),
  },

  // -----------------Ambulance routes-------------------


  {
    path: '/live-tracking/:bookingId',
    name: 'LiveTrackingPage',
    component:() => import("@/ambulance-tracker/LiveTrackingPage.vue"),
    props: true,
  },
   {
    path: "/pharmacies",
    name: "PharmacyMapPage",
    component: () => import("@/ambulance-tracker/PharmacyList.vue")
  },
 {
    path: "/book-ambulance/:subDepartmentId",
    name: "BookAmbulance",
    component:() => import("@/ambulance-tracker/BookAmbulance.vue")
    },

 {
    path: "/payment/:bookingId",
    name: "Payment",
    component: () => import("@/ambulance-tracker/PaymentPage.vue"),
    props: true,
  },
 {
   path: "/invoice/:invoiceId",
    name: "InvoicePage",
    component: () => import("@/ambulance-tracker/InvoicePage.vue"),
    props: true,
  },


 {
    path: "/invoices",
    name: " Inovice Dashboard",
    component: () => import("@/InvoiceModels/InvoiceDashboard.vue")
  },

{
        path: "/driver/:company_code/:userId",
        name: "DriverProfile",
        component:()=> import("@/profiles/driver-profile/DriverProfile.vue")
      },




  {
    path: "/addAmubulance",
    name: "AddAmubulance",
    component: () => import("@/ambulance-tracker/AddAmubulance.vue")
  },
  {
    path: "/companyDetails/:company_code",
    name: "CompanyDetails",
    component: () => import("@/ambulance-tracker/CompanyDetails.vue")
  },
  {
    path: "/confirmambulancerequest",
    name: "ConfirmAmbulanceRequest",
    component: () => import("@/ambulance-tracker/ConfirmAmbulanceRequest.vue")
  },
  {
    path: "/createAmbulance",
    name: "CreateAmbulance",
    component: () => import("@/ambulance-tracker/CreateAmbulance.vue")
  },
  {
    path: "/createcustomer",
    name: "CreateCustomer",
    component: () => import("@/ambulance-tracker/CreateCustomer.vue")
  },
  {
    path: "/displayMap",
    name: "displayMap",
    props: true,
    component: () => import("@/ambulance-tracker/DisplayMap.vue")
  },
  {
    path: "/doctorscategory",
    name: "DoctorsCategory",
    component: () => import("@/ambulance-tracker/DoctorCategory.vue")
  },
  {
    path: "/doctorsmap",
    name: "DoctorsMap",
    component: () => import("@/ambulance-tracker/DoctorsMap.vue")
  },
  {
    path: '/doctor-map/:doctorId',
    name: 'DoctorMap',
    component: () => import('@/ShowAllDoctors/DoctorMap.vue'),
  },
  {
    path: "/hospitalList",
    name: "HospitalList",
    component: () => import("@/ambulance-tracker/HospitalList.vue")
  },
  {
    path: "/origindestinationform",
    name: "OrigindestinationForm",
    component: () => import("@/ambulance-tracker/OriginDestinationForm.vue")
  },
    {
  path: '/received-files',
  name: 'ReceivedFiles',
  component: () => import('@/upload-files/ReceivedFiles.vue'),
},



{
  path: "/marketing",
  name: "marketing",
  component: () => import("../Affiliate_Associate_management/AllMarketingAssociates.vue"),
},
// Coordinators route
{
  path: "/coordinators",
  name: "coordinators",
  component: () => import("../Affiliate_Associate_management/AllCoordinators.vue"),
},
  // {
  //   path: "",
  //   name: "",
  //   component: () => import("@/ambulance-tracker/popup.vue")
  // },

  // ----------Doctor appointment card----------------------
  


  // -------------------My Articals------------------------
  {
    path: "/allArticleCards",
    name: "AllArticleCards",
    component: () => import("@/education-article/AllArticleCards.vue")
  },
  {
    path: "/myArticleCards",
    name: "myArticleCards",
    component: () => import("@/education-article/MyArticleCards.vue")
  },
  {
    path: "/ArticleById/:id",
    name: "ArticleById",
    component: () => import("@/education-article/ArticlebyId.vue")
  },
  {
    path: "/CreateArticle",
    name: "CreateArticle",
    component: () => import("@/education-article/CreateArticle.vue")
  },
  {
    path: "/scheduledArticles",
    name: "scheduledArticles",
    component: () => import("@/education-article/ScheduledArticles.vue")
  },
  // new Editor routes

{
    path: "/newEditor",
    name: "newEditor",
    component: () => import("@/Editor_November/newEditor.vue")
  },
  // -------------Letter & Drafts-------------------------
  {
    path: "/editorPageTemplate/:templateId?",
    name: "EditorPageTemplate",
    props: true,  // This allows you to pass params to the component
    component: () => import("@/LetterAndDrafts/EditorPage.vue")
  },
  {
    path: "/templateList",
    name: "TemplateList",
    component: () => import("@/LetterAndDrafts/TemplateListPage.vue")
  },
  {
    path: "/templateSelectionPage",
    name: "TemplateSelectionPage",
    component: () => import("@/LetterAndDrafts/TemplateSelectionPage.vue")
  },
  {
    path: "/PreviewDocument/:templateId",
    name: "PreviewDocument",
    component: () => import("@/LetterAndDrafts/previewDocument.vue")
  },
  {
    path: "/shareTemplate",
    name: "shareTemplate",
    component: () => import("@/LetterAndDrafts/shareTemplate.vue")
  },
  {
    path: "/sentTemplates",
    name: "sentTemplates",
    component: () => import("@/LetterAndDrafts/sentTemplatesToUsers.vue")
  },


  {
    path: "/SharedTemplatesWithME",
    name: "SharedTemplatesWithME",
    component: () => import("@/LetterAndDrafts/SharedTemplatesWithME.vue")
  },
  //family routes start
  {
    path: "/InviteFamilyMember",
    name: "InviteFamilyMember",
    component: () => import("../invite-member/InviteFamilyMember.vue"),
  },
  {
    path: "/AdminFamilyDashboard",
    name: "AdminFamilyDashboard",
    component: () => import("../FamilyManagement/AdminFamilyDashboard.vue"),
  },
  {
    path: "/familyPlans",
    name: "FamilyPlans",
    component: () => import("../FamilyManagement/FamilyPlans.vue"),
  },
  {
    path: "/planDetails/:planId",
    name: "PlanDetails",
    params: true,
    component: () => import("../FamilyManagement/components/PlanDetails.vue"),
  },
  {
    path: "/planSummary/:planId",
    name: "PlanSummary",
    params: true,
    component: () => import("../FamilyManagement/PlanSummary.vue"),
  },
  {
    path: "/familyPlan/payment/:planId",
    name: "FamilyPlanPayment",
    params: true,
    component: () => import("../FamilyManagement/MakePayment.vue"),
  },
  {
    path: "/FamilyManagement",
    name: "FamilyManagement",
    component: () => import("../FamilyManagement/FamilyManagement.vue"),
  },
  {
    path: "/all-members-list",
    name: "patientList",
    component: () => import("../FamilyManagement/patientLIst.vue"),
  },
  {
    path: "/find-yourself-in-others-family",
    name: "findYourselfInOthersFamily",
    component: () => import("../FamilyManagement/FindYourselfInOthersFamily.vue"),
  },

  {
    path: "/forgotresetpassword",
    name: "forgotresetpassword",
    component: () => import("@/login/login/forgot_resetPass.vue"),
    meta: {
       resetpassword: true
    },
  },


  {
    path: "/I_am_following_details",
    name: "IAmFollowing",
    component: () => import("@/profiles/doctor-profile/IAmFollowing.vue")
  },
     {
    path: "/my-followers",
    name: "MyFollowers",
    component: () => import("@/profiles/doctor-profile/MyFollowers.vue")
  },
{
  // New Vue Router 4 syntax for catch-all routes
  path: '/Coming_Soon',
  name: 'ComingSoon',
  component: () => import('@/notFoundPage/Comingsoon.vue'),
  meta: {
    title: 'Coming Soon'
  }
},
  // notification routes start
  {
    path:"/notificationspage",
    name:"NotificationPages",
    component: () => import('@/notification/NotificationPages.vue'),
  },
  // end
  {
    path: "/",
    name: "home",
        component: () => import("@/notification/component/RecoveryNotification.vue"),
  },

  // OPD Module 
  { path: "/calander_component/:userId", 
    name: 'calandercomponent', 
    component: () => import('../OPD_Module/calandercomponent.vue'), 
  },
{ path: '/opd_billing', 
  name: 'opd_billing', 
  component: () => import('../OPD_Module/opd_billing.vue'), 
},

 { path: '/dashboard_OPD_Module', 
  name: 'dashboard_OPD_Module', 
  component: ()=> import('../OPD_Module/dashboard_OPD_Module.vue') 
},

 { path: '/customer_patient_registration', 
  name: 'customer_patient_registration', 
  component: () => import('../OPD_Module/customer_patient_registration.vue'), 
},

 { path: '/dashboard_OPD_Module', 
  name: 'dashboard_OPD_Module', 
  component: ()=> import('../OPD_Module/dashboard_OPD_Module.vue') 
},



  //Notification Routes
  {
    path: "/notifications",
    name: "NotificationPage",
    component: () => import("@/notification/NotificationPage.vue"),
    children: [
      {
        path: "",
        redirect: "/notifications/admin", // Redirect to admin dashboard
      },
      {
        path: "admin",
        name: "AdminNotificationDashboard",
        component: () => import("@/notification/AdminNotificationDashboard.vue"),
      },
      {
        path: "registration",
        name: "RegistrationNotificationPage",
        component: () => import("@/notification/component/RegistrationNotification.vue"),
      },
      {
        path: "login",
        name: "LoginNotificationPage",
        component: () => import("@/notification/component/LoginNotification.vue"),
      },
      {
        path: "recovery",
        name: "RecoveryNotificationPage",
        component: () => import("@/notification/component/RecoveryNotification.vue"),
      },
      {
        path: "referral",
        name: "ReferralNotificationPage",
        component: () => import("@/notification/component/ReferralNotification.vue"),
      },

    ],
  },

  {
    path: "/doctor-calender-setup",
    name: "DoctorCalenderSetup",
    component: () => import("@/doctor-appointment/DoctorCalenderSetup.vue"),
  },

  {
    path: "/book-doctor-appointment/:doctorId",
    name: "BookDoctorAppointment",
    component: () => import("@/doctor-appointment/BookDoctorAppointment.vue"),
  },

  // import PatientAppointmentScheduler from "../Appointment_Model/PatientAppointmentScheduler.vue";
  // import PatientAppointmentBooking from "../Appointment_Model/PatientAppointment.vue";

  // {
  //   path: "/PatientAppointmentScheduler/:va_id?/:client_id?",
  //   name: "PatientAppointmentScheduler",
  //   component: PatientAppointmentScheduler,
  // },

  {
    path: "/PatientAppointmentBooking/:va_id?/:client_id?/:resumeId",
    name: "PatientAppointmentBooking",
    component: () => import("../Appointment_Model/PatientAppointment.vue"), //PatientAppointmentBooking,
  },

  {
    path: "/View_profile/:userId", //'/View_profile/:id'
    name: "view-Doctor",
    component: () => import("../ViewDoctorProfile/viewDoctorProfile.vue"),
  },

  {
    path: "/my-appointment-daybook",
    name: "appointmentBlock",
    component: () => import("../AppointmentBlock/appointmentBlock.vue"),
  },

  {
    path: "/patientAppointmentBlock",
    name: "patientAppointmentBlock",
    component: () => import("../AppointmentBlock/patientAppointmentBlock"),
  },
  {
    path: "/referralBlock",
    name: "referralBlock",
    component: () => import("../AppointmentBlock/ReferralBlock.vue"),
  },
  {
    path: "/referralBlock/:referralId",
    name: "referralDetails",
    component: () => import("../AppointmentBlock/ReferralDetails.vue"),
  },
  {
    path: "/child/:id",
    name: "ChildProfile",
    component: () => import("../profiles/child-profile/ChildProfile.vue"),

  },
{
    path: "/proforma-invoice/:id",
    name: "proforma-invoice",
    component: () => import("../invoice/performa_invoice.vue"),
  },
     {
  path: "/templates/preview/:id",
  name: "templatePreview",
  component: () => import("../template-builder/TemplateBuilder.vue"),
  meta: { mode: "preview" }   // 🔑 IMPORTANT
},
  {
    path: "/prescription-template",
    children: [
      {
        path: "",
        name: "PrescriptionTemplate",
        // component: () => import("../pages/PrescriptionTemplates.vue"),
        component: () => import("../template-builder/alltemplates.vue"),
      },
      {
        path: ":id",
        name: "editTemplate",
        component: () => import("../template-builder/TemplateBuilder.vue"),
      },
      {
        path: "new",
        name: "newTemplate",
        component: () => import("../template-builder/TemplateBuilder.vue"),
      },
    ],
  },

  
  {
    path:"/pre-consultation",
    name:"PreConsultationEditor",
    component: () => import("../template-builder/PreOrPostConsultationEditor.vue")
  },
  {
    path:"/post-consultation",
    name:"PostConsultationEditor",
    component: () => import("../template-builder/PreOrPostConsultationEditor.vue")
  },

  {
    path: "/prescription/:id",
    name: "prescription",
    component: () => import("../template-builder/PrescriptionBuilder.vue"),
  },
  {
    path: "/prescription-preview/:id",
    name: "prescriptionPreview",
    component: () => import("../template-builder/PrescriptionPreview.vue"),
  },
   {
    path: "/prescription/history/:patientId",
    name: "PrescriptionHistory",
    component: () => import("../template-builder/PrescriptionHistory.vue"),
  },
  {
    path: "/test/:id",
    name: "prescriptiontest",
    component: () => import("../timelines/PrescriptionBuilder.vue"),
  },
  {
    path: "/testbeforepaymentquestion",
    name: "testbeforepaymentquestion",
    component: () => import("../pop-up/questionnaire/beforePayment.vue"),
  },

  {
    path: "/companySearch",
    name: "CompanySearch",
    component: () => import("../template-builder/companySearch.vue"),
  },
  {
    path: "/reportActive/:id",
    name: "ReportActive",
    component: () => import("../template-builder/reportActive.vue"),
  },

  {
    path: "/workforce",
    name: "Workforce",
    component: () => import("../template-builder/workforceuser.vue"),
  },
  {
    path: "/patientblock",
    name: "patientblock",
    component: () => import("../template-builder/patientbllockdata.vue"),
  },
  // {path:'/templateprescription/:id',name:"TemplatePrescription",component:()=> import('../template-builder/TemplatePrescription.vue'),},
  {
    path: "/daybookbutton",
    name: "daybookbutton",
    component: () => import("../template-builder/daybookbutton.vue"),
  },
  {
    path: "/blockupdate",
    name: "blockupdate",
    component: () => import("../template-builder/blockupdate.vue"),
  },

  // questionnaire
  {
    path: "/questionnaire",
    name: "Questionnaire",
    component: () => import("@/questionnaire/questionnaire.vue"),
  },
  {
    path: "/questiongetonebyone",
    name: "Questiongetonebyone",
    component: () => import("@/questionnaire/questiongetonebyone.vue"),
  },
  // {
  //   path: "/NewPreappoint",
  //   name: "NewPreappoint",
  //   component: () => import("@/questionnaire/"),
  // },
  {
    path: "/patientAppointmentHistory",
    name: "patientAppointmentHistory",
    component: () => import("../AppointmentBlock/PatientAppointmentHistory.vue"),
  },
  {
    path: "/doctorAppointmentHistory",
    name: "doctorAppointmentHistory",
    component: () => import("../AppointmentBlock/DoctorAppointmentHistory.vue"),
  },

  {
    path: "/PreAppointmentPage/:userID",
    name: "PreAppointmentQuestionAnswer",
    component: () => import("@/questionnaire/PreAppointmentQuestions.vue"),
  },
  {
    path: "/showQustion",
    name: "ShowQustion",
    component: () => import("@/questionnaire/showDataPrescription.vue"),
  },
  {
    path: "/questionanswerpatient/:userID",
    name: "QuestionAnswerpatient",
    component: () => import("@/questionnaire/ShowQuestionAnswer.vue"),
  },

  //Z tracker
  {
    path: "/Z_Tracker",
    name: "Z_Tracker",
    component: ()=> import ( "@/AppointmentBlock/Z_Tracker.vue"),
  },

  //Health Tracker

  {
  path: '/dicom-uploader/:recordId',
  name: 'dicom-uploader',
  component: () => import('@/Dicom/components/DicomUploader.vue'),
  props: true
},

  
  {
    path: '/studies/:patientId?',
    name: 'studies',
    component: () => import('@/Dicom/components/StudyList.vue')
  },

   {
    path: '/viewdicomstudy',
    name: 'viewdicomstudy',
    component: () => import('@/Dicom/components/ViewDicomStudyList.vue')
  },

{
    path: '/viewer/:studyUID',
    name: 'viewer',
    component: () => import('@/Dicom/components/DicomViewer.vue')
  },


  {
    path: "/healthtracker",
    name: "Healthtracker",
    component: () => import("@/health_tracker/HealthTracker.vue"),
  },

  {
    path: "/inputtypefield",
    name: "InputTypeField",
    component: () => import("@/health_tracker/InputTypeField.vue"),
  },

  {
    path: "/newinputfield",
    name: "Newinputfield",
    component: () => import("@/health_tracker/newInputfield.vue"),
  },

  {
    path: "/patienthealthtracker",
    name: "patientHealthtracker",
    component: () => import("@/health_tracker/patientHealthtracker.vue"),
  },
  {
    path: "/examination",
    name: "Examination",
    component: () => import("@/health_tracker/healthExamination.vue"),

  },
  {
    path: "/addthealth",
    name: "AddPatientHealthTracker",
    component: () => import("@/health_tracker/AddPatientHealthTracker.vue"),

  },

  {
    path: "/resulthealthtraker",
    name: "ResultHealthTraker",
    component: () => import("@/health_tracker/resultHealthtraker.vue"),
  },
  {
    path: "/healthnotification",
    name: "HealthNotification",
    component: () => import("@/health_tracker/HealthNotification.vue"),

  },
  {
    path: "/prescriptionInput",
    name: "PrescriptionInput",
    component: () => import("@/health_tracker/prescriptionhealth.vue"),

  },
  {
    path: "/userDashboard",
    name: "userDashboard",
    component: () => import("../Admin_Dashboard/userDashboard.vue"),
  },
  {
    path: "/my-bookings",
    name: "MyBookings",
    component: () => import("../Lab-Imaging-Booking/MyBookings.vue"),
        meta: {
      requiresAuth: true,
    },
  },
   {
    path: "/diagnostic-reports-report",
    name: "DiagnosticReportsReport",
    component: () => import("../Lab-Imaging-Booking/diagnosticreport.vue"),
        meta: {
      requiresAuth: true,
    },
  },

  {
    path: "/public_booking",
    name: "public_booking",
    component: () => import("../Lab-Imaging-Booking/public_booking.vue"),
        meta: {
      requiresAuth: true,
    },
  },
// email 
   {
    path: "/loginemail",
    name: "loginemail",
    component: () => import("../email/loginemail.vue"),
  },
  {
    path: "/sendemail",
    name: "sendemail",
    component: () => import("../email/SendMail.vue"),
  },
  {
    path: "/inbox",
    name: "inbox",
    component: () => import("../email/Inbox.vue"),
  },
  {
    path: "/emaildraft",
    name: "emaildraft",
    component: () => import("../email/emaildraft.vue"),
  },
  {
    path: "/sentmailbox",
    name: "sentmailbox",
    component: () => import("../email/sentmailbox.vue"),
  },
   {
  path: "/subscription",
  name: "SubscriptionPage",
  component: () => import("@/Chat/LanguageSubscription.vue")
},







// webniar routes
{
    path: "/VideoCalling",
    name: "video Call",
    component: () => import("../VideoCall/VideoCall.vue"),
  },
  {
    path: "/WebinarNotification",
    name: "WebinarNotification",
    component: () => import("@/VideoCall/WebinarNotification"),
  },
  {
    path: "/streamer",
    name: "Stream Doctor",
    component: () => import("@/VideoCall/Streaming.vue"),
  },
  {
    path: "/selective-invitation",
    name: "selectiveinvitation",
    component: () => import("../VideoCall/SelectiveInvitation.vue"),
  },
  {
    path: "/webinar-list",
    name: "webinarlist",
    component: () => import("../VideoCall/WebinarList.vue"),
  },
    {
  path: "/live-podcasts",
  component: () => import("../VideoCall/PublicWebinars.vue")
},
{
  path: "/create-public-podcast",
  component: () => import("../VideoCall/CreatePublicWebinar.vue")
},
  {
    path: "/webinar/:webinarId",
    name: "Webinar",
    component: () => import("../VideoCall/WebinarRoom.vue"),
  },
  {
    path: "/webinar-ended",
    name: "endWebinar",
    component: () => import("../VideoCall/WebinarEnded.vue"),
  },
  // end

  {
    path: "/",
    component: () => import("@/daybook-prototype/DaybookLayout.vue"),
    children: [
      // {
      //   path: "pharmacy",
      //   name: "PharmacyDaybook",
      //   component: () => import("@/daybook-prototype/PharmacyDaybook.vue")
      // },
          { 
        path: "pharmacy",
        name: "PharmacyDaybook",
        component: () => import("@/daybook-prototype/PharmacyDaybook.vue")
      },
      {
        path: "radiology",
        name: "RadiologyDaybook",
        component: () => import("@/daybook-prototype/RadiologyDaybook.vue")
      }
    ]
  },



  // e-commerce //
  {
    path: "/homeEcommerce",
    props: true,
    component: () => import("@/e-commerce/components/Home.vue"),
  },
  {
    path: "/moreproducts",
    name: "MoreProducts",
    component: () => import("@/e-commerce/components/moreProduct.vue"),

  },
  {
    path: "/productcart/:itemId/:companyCode?",
    name: "ProductCart",
    component: () => import("@/e-commerce/components/productCard.vue"),

  },
  {
    path: "/AddCart",
    component: () => import("@/e-commerce/components/addToCart.vue"),
    name: "AddCart"
  },
  {
    path: "/addresspage",
    component: () => import("@/e-commerce/components/addressPage.vue"),
    name: "Addresspage"

  },
  {
    path: "/orders",
    component: () => import("@/e-commerce/components/my-order.vue"),
    name: "Order"
  },
  // {
  // path: "/invoice",
  // component: () => import("@/e-commerce/components/")
  // },
  {
    path: "/coupon",
    component: () => import("@/e-commerce/components/coupon.vue")
  },
  {
    path: "/showAllproduct",
    component: () => import("@/e-commerce/components/ShowProductAll.vue"),
    name: "ShowAllproduct"
  },

  {
    path: "/orderConfirm",
    component: () => import("@/e-commerce/components/orderConfirm.vue"),
    name:"orderConfirm"
  },

  // {
  //   path: "/order_confirmation",
  //   component: () => import("@/e-commerce/components/orderThankyou.vue"),
  //   name:"orderThankyou"
  // },
  {
    path: "/checkOut",
    component: () => import("@/e-commerce/components/checkOut_new.vue"),
    name:"checkOut"
  },

  // Privacy condition
  {
    path: "/Terms",
    name: "Terms",
    component: () => import("../login/Landing Page Footer/termsConditions.vue"),
    meta: { requiresAuth: false,
      allowUnpaid: true
    }, // optional for clarity
  },

  {
    path: "/refundpolicy",
    name: "refundpolicy",
    component: () => import("../login/Landing Page Footer/returnrefundpolicy.vue"),
    meta: { requiresAuth: false }, // optional for clarity
  },

{
    path: "/PrivacyPolicy",
    name: "PrivacyPolicy",
    component: () => import("../login/Landing Page Footer/privacyPolicy.vue"),
    meta: { requiresAuth: false }, // optional for clarity
  },
{
    path: "/AboutUs",
    name: "AboutUs",
    component: () => import("../login/Landing Page Footer/aboutUs.vue"),
    meta: { requiresAuth: false },
      // meta: { topbar_sidebar_hide: false },
  },

  {
    path: "/contactUs",
    name: "AboutUs",
    component: () => import("../login/Landing Page Footer/contact_us.vue"),
    meta: { requiresAuth: false },
      // meta: { topbar_sidebar_hide: false },
  },
  // * this is for showcase page
    { 
      path:"/createAlbums",
      name: "showcase",
      component: () => import("@/NewAlbum/Showcase.vue")
    },
  
      { 
      path:"/showcase_folders",
      name: "showcase_folders",
      component: () => import("@/NewAlbum/ShowcaseList.vue")
    },


  //Health Tracker

  {
    path: "/healthtracker",
    name: "Healthtracker",
    component: () => import("@/health_tracker/HealthTracker.vue"),
  },

  {
    path: "/createhealthinput",
    name: "CreateHealthInput",
    component: () => import("@/health_tracker/InputTypeField.vue"),
  },
  {
    path: "/healthmonitor",
    name: "HealthMonitor",
    component: () => import("@/health_tracker/healthExamination.vue"),

  },
  {
    path: "/patientinputhealthtraker",
    name: "PatientInputHealthTraker",
    component: () => import("@/health_tracker/patientHealthtracker.vue"),
  },
  
  {
    path: "/healthTrackerChart",
    name: "HealthTrackerChart",
    component: () => import("@/health_tracker/AddPatientHealthTracker.vue"),

  },

  {
    path: "/patientresulthealthtraker",
    name: "PatientResultHealthTraker",
    component: () => import("@/health_tracker/resultHealthtraker.vue"),
  },
  {
    path: "/healthnotification",
    name: "HealthNotification",
    component: () => import("@/health_tracker/HealthNotification.vue"),

  },
  {
    path: "/user/:userID",
    name: "UserProfile",
    component: () => import("@/qr/UserProfile.vue"),
    meta: {
      topbar_sidebar_hide: false,
    },

  },
  {
    path: "/servermoniter",
    name: "servermoniter",
    component: () => import("@/qr/servermoniter_details.vue"),
    meta: {
      topbar_sidebar_hide: false,
    },

  },
  {
    path: "/reportdownload",
    name: "reportdownload",
    component: () => import("@/qr/reportdownload.vue"),
    meta: {
      topbar_sidebar_hide: false,
    },

  },
  // renew
  { 
  path: "/renew-subscription/:userId",
  name: "RenewSubscription",
  component: () => import("@/invite-member/renew-subscription.vue"),
  meta: { 
    topbar_sidebar_hide: false,
    requiresAuth: false,        // ✅ Already false - good
    allowUnpaid: true,
    requiresPlanSelection: false,
    isPublic: true              // ✅ Add this flag
  },    
},


  //OCR Routes
  {
    path: '/ocr_report',
    name: 'ocr_report',
    component: () => import("@/ocr/OcrView.vue")
  },

  // //pharmacy daybook

  // {
  //   path: "/pharmacy-daybook",
  //   name: "PharmacyDayBook",
  //   component: () => import("@/daybook-prototype/PharmacyDayBook.vue")
  // },

   //favorite
  {
    path:"/favorite",
    name: "favorite",
    children : [
      {
        path: "medicines",
        name: "favMeds",
        component: () => import("@/favorite/FavMedicines.vue")
      }
    ]
  },

];

const router = createRouter({
  
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0, left: 0 };
    }
  }
});
// router.beforeEach(async (to, from, next) => {
//   const user = JSON.parse(sessionStorage.getItem("user") || "{}");
//   // ✅ 1. Restrict routes based on payment_status
//   if (user && user.payment_status === false) {
//     const allowedRoutes = ["/", "/membership-plans"];
//     const isUserProfileRoute = to.path.startsWith("/user/");
//     if (!allowedRoutes.includes(to.path) && !isUserProfileRoute) {
//       console.log("Blocked route due to unpaid status:", to.path);
//       return next("/membership-plans");
//     }
//   }

//   console.log("Route changed from:", from.path, "to:", to.path);

//   const store = useStore();
//   // ✅ 2. Check permissions (only if user is logged in)
//   if (user && user._id) {
//     const userPermissions =await store.state.user.userPermissions || [];
//     const requiredPermission = to.meta.permission;
//     if (requiredPermission && !userPermissions.includes(requiredPermission)) {
//       console.warn("User does not have required permission:", requiredPermission);
//       return next("/"); // Redirect to homepage
//     }
//   }
//   next();
// });






export default router;

// Navigation Guard
// router.beforeEach(async (to, from, next) => {
//    console.log("TO PATH:", to.path);
//   console.log("TO META:", to.meta);
//   console.log("Route changed from:", from.path, "to:", to.path);
//   // Get user from session storage
//   let user = null;
//   try {
//     const userStr = sessionStorage.getItem("user") || localStorage.getItem("user") || "{}";
//     user = JSON.parse(userStr);
//     if (user && Object.keys(user).length === 0) {
//       user = null;
//     }
//   } catch (error) {
//     console.error("Error parsing user data:", error);
//     user = null;
//   }
  
//   // Check if user is logged in for routes that require authentication
//   if (to.meta.requiresAuth && (!user || !user._id)) {
//     console.log("Authentication required, redirecting to login");
//     sessionStorage.setItem('intendedRoute', to.fullPath);
//     return next('/login');
//   }
  
//   // ✅ 1. Handle unpaid users
//   if (user && user._id && user.payment_status === false) {
//     console.log("Unpaid user detected:", user._id, "payment_status:", user.payment_status);
    
//     // Routes that unpaid users can access
//     const allowedRoutes = ["/", "/membership-plans", "/Terms"];
//     const isUserProfileRoute = to.path.startsWith("/user/");
    
//     // Special handling for registration-payment route
//     if (to.path === "/registration-payment") {
//       const planSelected = hasSelectedPlan();
//       const hasQueryParam = !!(to.query.serviceId);
//       const isValidPlan = isValidSelectedPlan();
      
//       console.log("Payment page access check - planSelected:", planSelected, 
//                   "hasQueryParam:", hasQueryParam, 
//                   "isValidPlan:", isValidPlan);
      
//       if (!planSelected && !hasQueryParam) {
//         console.log("No plan selected, redirecting to membership plans");
//         if (from.path !== "/membership-plans") {
//           sessionStorage.setItem('redirectReason', 'no_plan_selected');
//         }
//         return next("/membership-plans");
//       }
      
//       if (planSelected && !isValidPlan) {
//         console.log("Invalid plan data, redirecting to membership plans");
//         clearSelectedPlan();
//         sessionStorage.setItem('redirectReason', 'invalid_plan');
//         return next("/membership-plans");
//       }
      
//       console.log("Plan selected and valid, allowing access to payment page");
//       return next();
//     }
    
//     // Check if route is allowed for unpaid users
//     if (!allowedRoutes.includes(to.path) && !isUserProfileRoute) {
//       console.log("Blocked route due to unpaid status:", to.path);
//       sessionStorage.setItem('intendedRoute', to.fullPath);
//       return next("/membership-plans");
//     }
//   }
  
//   // ✅ 2. Check for plan selection requirement (for routes that require it)
//   if (to.meta.requiresPlanSelection && user && user.payment_status !== false) {
//     const planSelected = hasSelectedPlan();
//     const hasQueryParam = !!to.query.serviceId;
//     const isValidPlan = isValidSelectedPlan();
    
//     if (!planSelected && !hasQueryParam) {
//       console.log("Route requires plan selection but no plan found:", to.path);
//       sessionStorage.setItem('redirectReason', 'no_plan_selected');
//       return next("/membership-plans");
//     }
    
//     if (planSelected && !isValidPlan) {
//       console.log("Invalid plan data for required route:", to.path);
//       clearSelectedPlan();
//       sessionStorage.setItem('redirectReason', 'invalid_plan');
//       return next("/membership-plans");
//     }
//   }
  
//   // ✅ 3. Check permissions (only if user is logged in and route requires permission)
//   if (user && user._id && to.meta.permission) {
//     try {
//       const store = useStore();
//       let userPermissions = store.state.user?.userPermissions || [];
      
//       if (userPermissions.length === 0 && store.dispatch) {
//         await store.dispatch('user/fetchUserPermissions', user._id);
//         userPermissions = store.state.user?.userPermissions || [];
//       }
      
//       const requiredPermission = to.meta.permission;
//       if (requiredPermission && !userPermissions.includes(requiredPermission)) {
//         console.warn("User does not have required permission:", requiredPermission);
//         return next("/unauthorized");
//       }
//     } catch (error) {
//       console.error("Error checking permissions:", error);
//     }
//   }
  
//   // ✅ 4. Clear any redirect reasons if we're successfully navigating
//   if (to.path === "/membership-plans") {
//     sessionStorage.removeItem('redirectReason');
//   }
  
//   // Clear intended route when accessing allowed pages
//   if (to.path === "/" || to.path === "/membership-plans" || to.path === "/registration-payment") {
//     sessionStorage.removeItem('intendedRoute');
//   }
  
//   next();
// });


router.beforeEach(async (to, from, next) => {
  console.log("TO PATH:", to.path);

  // ✅ 1. PUBLIC ROUTES (Add renew-subscription here)
  const publicRoutes = [
    "/",
    "/login",
    "/forgotresetpassword",
    "/registration-successful",
    "/PrivacyPolicy",
    "/Terms",
    "/renew-subscription",
    "/blogs"  // ✅ Add this
  ];

  // ✅ Also check for routes that start with /renew-subscription/
  const isRenewSubscriptionRoute = to.path.startsWith("/renew-subscription/");
  
  if (publicRoutes.includes(to.path) || isRenewSubscriptionRoute || to.meta.isPublic) {
    console.log("✅ Public route allowed:", to.path);
    return next();
  }

  // =============================
  // USER PARSE
  // =============================
  let user = null;
  try {
    const userStr =
      sessionStorage.getItem("user") ||
      localStorage.getItem("user") ||
      "{}";

    user = JSON.parse(userStr);

    if (user && Object.keys(user).length === 0) {
      user = null;
    }
  } catch (error) {
    console.error("Error parsing user:", error);
    user = null;
  }

  // =============================
  // AUTH CHECK (Skip for renew-subscription)
  // =============================
  if (to.meta.requiresAuth && (!user || !user._id) && !isRenewSubscriptionRoute) {
    console.log("❌ Not authenticated → login");
    sessionStorage.setItem("intendedRoute", to.fullPath);
    return next("/");
  }

  // =============================
  // UNPAID USER CHECK (Skip for renew-subscription)
  // =============================
  const isMembershipPlansRoute = to.path === "/membership-plans";

if (
  user &&
  user._id &&
  !isRenewSubscriptionRoute &&
  !isMembershipPlansRoute
) {
  // Company subscription status has priority
  const effectivePaymentStatus =
    user.COMPANY_PAYMENT_STATUS !== undefined
      ? user.COMPANY_PAYMENT_STATUS
      : user.payment_status;

  console.log(
    "🏢 COMPANY_PAYMENT_STATUS:",
    user.COMPANY_PAYMENT_STATUS
  );

  console.log(
    "👤 payment_status:",
    user.payment_status
  );

  console.log(
    "💳 Effective Payment Status:",
    effectivePaymentStatus
  );

  // =============================
  // SUBSCRIPTION EXPIRED / INACTIVE
  // =============================

  if (effectivePaymentStatus !== true) {
    console.log("⚠️ Subscription inactive:", to.path);

    const allowedRoutes = [
      "/",
      "/membership-plans",
      "/Terms",
      "/forgotresetpassword"
    ];

    const isUserProfileRoute = to.path.startsWith("/user/");
    const isRenewRoute = to.path.startsWith("/renew-subscription/");

    // =============================
    // REGISTRATION PAYMENT
    // =============================

    if (to.path === "/registration-payment") {
      const planSelected = hasSelectedPlan();
      const hasQueryParam = !!to.query.serviceId;
      const isValidPlan = isValidSelectedPlan();

      if (!planSelected && !hasQueryParam) {
        return next("/membership-plans");
      }

      if (planSelected && !isValidPlan) {
        clearSelectedPlan();
        return next("/membership-plans");
      }

      return next();
    }

    // =============================
    // BLOCK OTHER ROUTES
    // =============================

    if (
      !allowedRoutes.includes(to.path) &&
      !isUserProfileRoute &&
      !isRenewRoute
    ) {
      console.log("🚫 Blocked (subscription inactive):", to.path);

      return next("/membership-plans");
    }
  }
}
  // Rest of your guard code remains the same...
  
  // =============================
  // PLAN CHECK
  // =============================
  if (to.meta.requiresPlanSelection && user && user.payment_status !== false && !isRenewSubscriptionRoute) {
    const planSelected = hasSelectedPlan();
    const hasQueryParam = !!to.query.serviceId;
    const isValidPlan = isValidSelectedPlan();

    if (!planSelected && !hasQueryParam) {
      return next("/membership-plans");
    }

    if (planSelected && !isValidPlan) {
      clearSelectedPlan();
      return next("/membership-plans");
    }
  }

  // =============================
  // PERMISSION CHECK
  // =============================
  if (user && user._id && to.meta.permission && !isRenewSubscriptionRoute) {
    try {
      const store = useStore();
      let userPermissions = store.state.user?.userPermissions || [];

      if (userPermissions.length === 0 && store.dispatch) {
        await store.dispatch("user/fetchUserPermissions", user._id);
        userPermissions = store.state.user?.userPermissions || [];
      }

      if (!userPermissions.includes(to.meta.permission)) {
        return next("/unauthorized");
      }
    } catch (error) {
      console.error("Permission error:", error);
    }
  }

  // =============================
  // CLEANUP
  // =============================
  if (to.path === "/membership-plans") {
    sessionStorage.removeItem("redirectReason");
  }

  if (
    to.path === "/" ||
    to.path === "/membership-plans" ||
    to.path === "/registration-payment"
  ) {
    sessionStorage.removeItem("intendedRoute");
  }

  next();
});

// After each navigation
router.afterEach((to, from) => {
  console.log("Navigation completed:", from.path, "->", to.path);
  
  const redirectReason = sessionStorage.getItem('redirectReason');
  if (redirectReason && to.path === '/membership-plans') {
    setTimeout(() => {
      // You can integrate with your toast notification system
      const toast = window.$toast || null;
      if (toast && toast.error) {
        if (redirectReason === 'no_plan_selected') {
          toast.error('Please select a membership plan first');
        } else if (redirectReason === 'invalid_plan') {
          toast.error('Invalid plan selection. Please choose again.');
        }
      } else {
        console.log('Please select a membership plan first');
      }
      sessionStorage.removeItem('redirectReason');
    }, 100);
  }
});